export default [
  {
    path: '/task-new-manager',
    component: () => import('@/views/taskNewManager/TaskNewManager.vue'),
    name: 'task-new-manager',
    meta: {
      title: 'Quản lý công việc',
      auth: true,
      // permission: 'task-new-manager-access',
    },
  },
  {
    path: '/config-task-role',
    component: () => import('@/views/taskNewManager/ConfigRoleTask.vue'),
    name: 'config-task-role',
    meta: {
      title: 'Phân quyền công việc',
      auth: true,
      // permission: 'task-new-manager-access',
    },
  },
  {
    path: '/task-report',
    component: () => import('@/views/taskNewManager/TaskNewReport.vue'),
    name: 'task-report',
    meta: {
      title: 'Báo cáo công việc',
      auth: true,
      // permission: 'task-new-manager-access',
    },
  },
]
